import { categories } from "@/mocks/data";

export default function Categories() {
  return (
    <section id="categories" className="bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="mb-3 text-sm font-medium text-secondary-700">
              <i className="ri-grid-fill mr-2"></i>
              瓜圈分类
            </div>
            <h2 className="font-heading text-2xl text-foreground-950 md:text-4xl">
              挑一个频道开蹲
            </h2>
            <p className="mt-3 max-w-xl text-sm text-foreground-600 md:text-base">
              按圈内领域分类整理,找到你关心的方向,蹲更新与定时刷新更精准。
            </p>
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {categories.map((c) => (
            <a
              key={c.id}
              href="#feed"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector("#feed")?.scrollIntoView({ behavior: "smooth" });
              }}
              className="group rounded-2xl bg-background-50 p-5 text-center transition-all hover:-translate-y-1 hover:bg-background-50 md:p-6"
            >
              <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-secondary-100 text-xl text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50 md:h-14 md:w-14">
                <i className={c.icon}></i>
              </span>
              <h3 className="mt-4 text-sm font-semibold text-foreground-900 md:text-base">
                {c.name}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{c.desc}</p>
              <div className="mt-3 text-xs font-medium text-primary-500">{c.count}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}